<!--
 * @Author: zxl
 * @Date: 2020-03-17 18:17:44
 * @FilePath: \serveradmin_frontend\src\App.vue
 * @Description: 
 -->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<style>
@import './assets/css/main.css';
@import './assets/css/color-dark.css'; /*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>
<script>
export default {
  name: 'App',
    data () {
        return {
            isRouterAlive: true
        }
  },
  created() {
    Date.prototype.format = function(fmt) {
      var o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
        }
      }
      return fmt
    }
  },
  provide(){ //提供
      return {
          reload: this.reload
      }
  },
  methods: {
    reload(){
      this.isRouterAlive=false
			this.$nextTick(()=>this.isRouterAlive=true)
    }
  }
  
}
</script>